import makeQueryString from './makeQueryString';

const addParamsToHash = (url: string, params = {}) => {
  const queryString = makeQueryString(params);
  return `${url}#${queryString}`;
};

export default addParamsToHash;
